import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import PropTypes from 'prop-types';
import { withDetailedIcon } from '../DetailedIcon';
export var TrowelSVG = function TrowelSVG(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M29.946,39.171a4.449,4.449,0,0,1,.042.829h8.131a2.081,2.081,0,0,0,1.851-2.517C38.94,30.952,33.973,26,28,26a10.862,10.862,0,0,0-5.724,1.658A15.849,15.849,0,0,1,29.946,39.171Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M27.99,40a2.375,2.375,0,0,1-.29,1,1.853,1.853,0,0,1-1.58,1H5.88a2.077,2.077,0,0,1-1.85-2.52C5.06,32.95,10.03,28,16,28a10.968,10.968,0,0,1,2.37.27c.37.09.73.19,1.09.31a9.258,9.258,0,0,1,1.03.42,13.732,13.732,0,0,1,7.48,10.48A2.287,2.287,0,0,1,27.99,40Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__secondary-color-fill",
    d: "M11.884,26.818h-.005"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M22.372,7.176h0a1.293,1.293,0,0,1,0,2.586h0a1.294,1.294,0,1,0,0-2.587Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__accent-color-fill",
    d: "M22.333,4.587a3.255,3.255,0,0,0-3.239,3.137l.937,9.8h4.6l.937-9.8A3.254,3.254,0,0,0,22.333,4.587Zm.948,4.8a1.287,1.287,0,0,1-.907.377h-.01a1.368,1.368,0,0,1-.5-.1,1.428,1.428,0,0,1-.408-.275A1.3,1.3,0,0,1,21.651,7.4a1.271,1.271,0,0,1,.723-.224,1.289,1.289,0,0,1,.907,2.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__no-fill",
    d: "M30.746,21.4v7.761a4.18,4.18,0,0,1-1.578,2.954l-5.4,3.595a2.923,2.923,0,0,1-2.872,0l-5.4-3.595a4.181,4.181,0,0,1-1.579-2.954V21.4a1.309,1.309,0,0,1,1.294-1.294H21.04v6.468a1.294,1.294,0,0,0,2.587,0V20.109h5.826A1.308,1.308,0,0,1,30.746,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M31.49,18.123a3.791,3.791,0,0,0-2.037-.6H27.232l.927-9.7a5.826,5.826,0,0,0-11.652,0l.927,9.7h-2.22a3.789,3.789,0,0,0-2.037.6,3.866,3.866,0,0,0-1.844,3.28v7.761a6.661,6.661,0,0,0,2.73,5.1l5.4,3.595a5.542,5.542,0,0,0,5.745,0l5.4-3.595a6.66,6.66,0,0,0,2.729-5.1V21.4A3.865,3.865,0,0,0,31.49,18.123ZM22.333,4.587a3.254,3.254,0,0,1,3.239,3.137l-.937,9.8h-4.6l-.937-9.8A3.255,3.255,0,0,1,22.333,4.587Zm8.413,24.577a4.18,4.18,0,0,1-1.578,2.954l-5.4,3.595a2.923,2.923,0,0,1-2.872,0l-5.4-3.595a4.181,4.181,0,0,1-1.579-2.954V21.4a1.309,1.309,0,0,1,1.294-1.294H21.04v6.468a1.294,1.294,0,0,0,2.587,0V20.109h5.826A1.308,1.308,0,0,1,30.746,21.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M23.66,8.47a1.291,1.291,0,1,0-1.29,1.293A1.3,1.3,0,0,0,23.66,8.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "DetailedIcon__foreground-color-fill",
    d: "M21.078,8.47A1.3,1.3,0,0,1,22.37,7.177h0a1.294,1.294,0,0,0,0,2.587h0A1.3,1.3,0,0,1,21.078,8.47Z"
  }));
};
TrowelSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
TrowelSVG.defaultProps = {
  children: /*#__PURE__*/React.createElement("title", null, "Trowel")
};
export default withDetailedIcon(TrowelSVG);